import { Pipe, PipeTransform } from '@angular/core';
import anchorme from 'anchorme';

@Pipe({
	name: 'addHtmlLinks',
	pure: true,
	standalone: false
})
export class AddHtmlLinksPipe implements PipeTransform {
	transform(text?: string | null): string | undefined {
		if (!text) {
			return undefined;
		}

		const textWithLinks: string = anchorme({
			input: text,
			options: {
				attributes: {
					target: '_blank'
				},
				truncate: 350,
				middleTruncation: true,
				// Emails & files will be excluded
				exclude: (string: string) => {
					if (anchorme.validate.email(string)) {
						return true;
					} else if (string.startsWith('file:///')) {
						return true;
					} else {
						return false;
					}
				}
			}
		});

		return textWithLinks;
	}
}
